import React from "react";

/**
 *
 * User : 이연우
 * Date : 2023.05.31
 * @ file : Components/Common/CpmCommTextarea.js
 * @ Desc : textarea 컴포넌트
 * @param {string} id - id값 (부모 컴포넌트의 파라미터 key 값으로도 사용)
 * @param {object} params - 부모 컴포넌트로부터 받아온 파라미터 객체
 * @param {React.SetStateAction} setParams - 부모 컴포넌트로부터 받아온 파라미터 세터
 * @param {number} rows - 문자열 개수
 * @param {boolean} isDisabled - disabled Yn
 * @param {string} label - 라벨
 * @param {boolean} essential - 필수 여부
 */

const CpmCommTextarea = ({
    id, 
    params, 
    setParams, 
    rows, 
    isDisabled,
    label,
    essential = false,
}) => {
    const paramNm = id || 'textarea'

    const onChangeInput = (e) => {
        setParams({[paramNm]: e.target.value});
    };

    return (
        <>
            <textarea
                    name={label || paramNm}
                    className={`${essential && 'essential'} form-control`}
                    id={id}
                    rows={rows || 2}
                    onChange={onChangeInput}
                    value={params[paramNm] || ''}
                    disabled={isDisabled}
                    maxLength={200}
                    autoComplete="off"
            />
        </>
    );
};

export default CpmCommTextarea;
